<template>
  <div class="completion-text">{{ lang.SET500 }}</div>
</template>

<script>
export default {
  name: "CompletionMessageComponent",
  props: {
    data: { type: Object, default: () => {} },
  },
  data() {
    return {
      lang: {
        SET500: "Thank you! We process your invoice!",
      },
    };
  },
  mounted() {
    this.globals.getLanguageStrings(this);
  },
};
</script>

<style>
.completion-text {
  font-size: 30px;
}

@media (max-width: 1000px) {
  @media screen and (max-aspect-ratio: 13/9) {
    .completion-text {
      font-size: 1.8em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// CompletionMessage.vue?2f5dbf04